import { defineStore } from 'pinia';

const STORAGE_KEY = 'partner-ref';

export const usePartnerRefStore = defineStore('partnerRef', {
  state: () => ({
    ref: null
  }),

  actions: {
    capture(incomingRef) {
      if (!incomingRef || this.ref) {
        return;
      }

      const normalized = String(incomingRef).trim().toLowerCase();

      if (normalized) {
        this.ref = normalized;
      }
    },

    clear() {
      this.ref = null;
    }
  },

  persist: {
    key: STORAGE_KEY,
    storage: sessionStorage,
    paths: ['ref']
  }
});
